module.exports = __webpack_public_path__ + "static/media/qtum.0ca8bfad.png";